import pkceChallenge, {
  verifyChallenge,
  generateChallenge,
} from "pkce-challenge";

import type { IPKCE } from "byzantine";

const webPKCE: IPKCE = {
  pkceChallenge,
  verifyChallenge,
  generateChallenge,
};

export default webPKCE;
